"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GINGERSNAP_DOWNLOADS_LOCATION_PREFIX = exports.GINGERSNAP_TASK_QUEUE = void 0;
exports.GINGERSNAP_TASK_QUEUE = 'GINGERSNAP_QUEUE';
exports.GINGERSNAP_DOWNLOADS_LOCATION_PREFIX = 'gingersnap:downloads/';
//# sourceMappingURL=task-queue.js.map